module.exports = __webpack_public_path__ + "static/media/mission-pin-vector.fc2f9d48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/mission-pin-vector.svg
// module id = 1200
// module chunks = 1